import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { getFormValues } from 'redux-form/immutable';
import { Field } from '../../../common/form';
import { getSystemEnumList } from '../../../reducer';

const ScoringAnswerSyncView = ({ id, proxyValue, isList, rankMapping }) => (
  <Field
    name={`surveyQuestionAttributes.${id}.extra.scoringAnswer${isList ? 'Item' : ''}`}
    component={({ input: { value, onChange } }) => {
      if (!proxyValue) {
        return '';
      }
      if (value !== proxyValue) {
        if (rankMapping) {
          onChange(rankMapping.get(proxyValue));
        } else {
          onChange(proxyValue);
        }
      }
      // return <h2>ANSWER: {proxyValue}</h2>;
      return <div style={{ display: 'none' }} />;
    }}
  />
);
ScoringAnswerSyncView.propTypes = {
  id: PropTypes.string.isRequired,
  proxyValue: PropTypes.string,
  isList: PropTypes.bool.isRequired,
  rankMapping: PropTypes.instanceOf(Map),
};
ScoringAnswerSyncView.defaultProps = {
  proxyValue: undefined,
  rankMapping: undefined,
};

const ScoringAnswerSync = connect((state, { choice }) => {
  const id = `${choice.get('id')}`;
  const proxyKey = choice.getIn(['scoringPolicy', 'scoringAnswerSource']);
  const proxySource = ['surveyQuestionAttributes', id, 'extra', 'questionPlaceholders', proxyKey];
  const enumId = choice.getIn(['extra', 'setupQuestionPlaceholders', proxyKey, 'enumId']);
  const answerType = choice.getIn(['extra', 'setupQuestionPlaceholders', proxyKey, 'type']);
  const policy = choice.getIn(['scoringPolicy', 'policy']); // 'minimum-rank', 'intersect', 'minimum-age'
  const formValue = getFormValues('jobForm')(state).getIn(proxySource);
  const proxyValue = formValue;

  let rankMapping;
  const rankedValues = choice.getIn(['scoringPolicy', 'rankedValues']); // ordered set of enum slugs (optional)
  if (enumId && rankedValues) {
    const enumList = enumId && getSystemEnumList(state, enumId);
    rankMapping = enumList.reduce((mapping, value) => mapping.set(value.get('slug'), rankedValues.indexOf(value.get('slug'))), Map());
  }

  return {
    proxyValue,
    proxySource,
    answerType,
    enumId,
    policy,
    id,
    rankMapping,
    isList: policy === 'intersect',
  };
  // if (enumId) {
  //   // TODO: translate value into slug
  // }
})(ScoringAnswerSyncView);

export default ScoringAnswerSync;
